// services/resultEntryService.js
import axios from 'axios';

import { BASE_URL } from '../utils/BaseUrl';

// Create axios instance with interceptors
const api = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export const resultEntryService = {
  // Get pending tests for result entry
  getPendingTests: async (page = 1, limit = 20, search = '', status = '') => {
    const response = await api.get('/results/bystatus', {
      params: { page, limit, search, status } // ✅ Send status parameter
    });
    return response.data;
  },
  // ✅ NEW: Get result entry by ID
  getResultById: async (resultId) => {
    const response = await api.get(`/results/${resultId}`);
    return response.data;
  },

  // Initialize result entry for a booking
  initializeResultEntry: async (bookingId) => {
    const response = await api.get(`/results/initialize/${bookingId}`);
    return response.data;
  },

  // Update test results for a service
  updateTestResults: async (resultId, serviceId, updateData) => {
    const response = await api.put(
      `/results/update/${resultId}/service/${serviceId}`,
      updateData
    );
    return response.data;
  },
  // Add to your resultEntryService
  calculateOnFrontend: async (formula, values) => {
    const response = await api.post('/result-entry/calculate-frontend', {
      formula,
      values
    });
    return response.data;
  },

  // Verify results
  verifyResults: async (resultId, serviceId, verificationData) => {
    const response = await api.post(
      `/results/verify/${resultId}/service/${serviceId}`,
      verificationData
    );
    return response.data;
  },

  // Release results
  releaseResults: async (resultId, releaseData) => {
    const response = await api.post(
      `/results/release/${resultId}`,
      releaseData
    );
    return response.data;
  },

  // Get result by barcode
  getResultByBarcode: async (barcode) => {
    const response = await api.get(`/results/barcode/${barcode}`);
    return response.data;
  },

  // Calculate derived results
  calculateDerivedResults: async (resultId, serviceId) => {
    const response = await api.post(
      `/results/calculate/${resultId}/service/${serviceId}`
    );
    return response.data;
  }
};

export default api;